import { Reveal, SectionHead } from "./Reveal";

const CASES = [
  {
    id: "lectures",
    img: "https://images.unsplash.com/photo-1623466453024-1d31e5cd3605?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Lectures & seminars",
    text: "Listen to the professor instead of racing to write. Tilla' catches every definition, every \"this will be on the exam\" and every deadline.",
  },
  {
    id: "study-groups",
    img: "https://images.unsplash.com/photo-1769092992447-18050cf9bd26?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Study groups & projects",
    text: "Who's doing the slides? When's the next meeting? Tilla' turns the group chat-out-loud into a task list everyone can follow.",
  },
];

export const UseCases = () => (
  <section id="use-cases" data-testid="use-cases-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHead eyebrow="Built for students" title="Be present in class. Let Tilla' take the notes." />
      <div className="grid gap-6 lg:grid-cols-2">
        {CASES.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.1}>
            <article data-testid={`use-case-${c.id}`} className="group overflow-hidden rounded-2xl border border-white/10 bg-card">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={c.img} alt={c.title} loading="lazy" className="h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-semibold">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">{c.text}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
